module.exports = __webpack_public_path__ + "static/media/calendar-new.fd47821f.svg";